<template>
  <div>
    <div class="w-100 d-inline-block bg-introduction 
    padding-bottom-6">
      <div class="container autoContent">
        <div class="row margin-xl-top-4">
          <div class="col-12">
            <div class="w-100 d-inline-block text-center mt-xl-0 mt-4">
              <p class="mb-0 text-size-14 text-uppercase nav-color fw-bold family-filson-bold text-full-14">
                our gallery
              </p>
              <h2 class="half-black fw-bold text-size-20 text-full-20 family-filson-bold margin-top-2 margin-bottom-2">
                Keeping tails wagging...
              </h2>
            </div>
          </div>
        </div>
        <div class="row mt-3 mb-3">
          <div class="col-12">
            <div class="w-100 d-inline-block gallery-slider position-relative">
              <div class="carousel-container">
                <transition-group class="carousel" tag="div">
                  <div v-for="slide in slides" class="slide" :key="slide.id">
                    <!-- <img :src="slide.imgSrc" :alt="slide.title" class="slide-image" /> -->
                    <img :src="slide.imgSrc" :alt="slide.title" class="slide-image" />
                  </div>
                </transition-group>
                <div class="carousel-controls">
                  <a href="javascript:void(0)" class="carousel-prev-btn position-absolute" @click="previous">
                    <img class="position-absolute" src="@/assets/images/prev-left-icon.svg" alt="" />
                  </a>
                  <a href="javascript:void(0)" class="carousel-next-btn position-absolute" @click="next">
                    <img class="position-absolute" src="@/assets/images/next-right-icon.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "gallerySliderComponent",
    data() {
      return {
        slides: [
          {
            title: "pet care services, pet grooming tools",
            id: 1,
            imgSrc: require("@/assets/images/pet-care-services-pet-grooming-tools.svg"),
          },
          {
            title: "pet grooming training, professional grooming team",
            id: 2,
            imgSrc: require("@/assets/images/pet-grooming-training-professional-grooming-team.svg"),
          },
          {
            title: "pet groomer, pet grooming franchise",
            id: 3,
            imgSrc: require("@/assets/images/pet-groomer-pet-grooming-franchise.svg"),
          },
          {
            title: "mobile pet grooming, pet grooming prices",
            id: 4,
            imgSrc: require("@/assets/images/mobile-pet-grooming-pet-grooming-prices.svg"),
          },
          {
            title: "pet care services, pet grooming tools",
            id: 5,
            imgSrc: require("@/assets/images/pet-care-services-pet-grooming-tools.svg"),
          },
          {
            title: "pet grooming training, professional grooming team",
            id: 6,
            imgSrc: require("@/assets/images/pet-grooming-training-professional-grooming-team.svg"),
          },
          {
            title: "pet groomer, pet grooming franchise",
            id: 7,
            imgSrc: require("@/assets/images/pet-groomer-pet-grooming-franchise.svg"),
          },
          {
            title: "mobile pet grooming, pet grooming prices",
            id: 8,
            imgSrc: require("@/assets/images/mobile-pet-grooming-pet-grooming-prices.svg"),
          },
        ],
      };
    },
    methods: {
      next() {
        const first = this.slides.shift();
        this.slides = this.slides.concat(first);
      },
      previous() {
        const last = this.slides.pop();
        this.slides = [last].concat(this.slides);
      },
    },
  };
</script>

<style scoped>
  /* Add any specific styles for your component here */
</style>
